import { createSelector } from 'reselect';

const getRoundInfo = (state: any) => state.roundInfoReducer.data;

export const getRoundsInfoData = createSelector(getRoundInfo, (state) => state);
